import { AppData } from '../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiResponseModel } from '../models/api_response_model';

import * as am from '../models/actor/actor';

import { ApiRequestModel } from '../models/api_request_model';
import { DownloadFileRequest } from '../models/docs/doc.model';
import { ChangePasswordRequest } from '../models/login/changepassword.model';
import { ChangeUserActivateRequest } from '../models/login/changeuseractivate.modal';
import { BaseClass } from '../models/master/mastermodel';


@Injectable()
export class ActorService {
  blob_options = {
    responseType: 'blob' as 'json'
  };

  constructor(private http: HttpClient, private injector: Injector, private router: Router) {


  }
  Get<Type>(SendRequest: Type, methodname: string) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}` + methodname,
      (SendRequest),
      {
        headers: new HttpHeaders()
          .set('AuthGenKEY', AppData.Instance()
            .UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  Save<Type>(SendRequest: Type, methodname: string) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}` + methodname,
      (SendRequest),
      {
        headers: new HttpHeaders()
          .set('AuthGenKEY', AppData.Instance()
          .UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }


  GetMisReportByType(req: am.MisReportRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Report/xyReport`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMisReportCategoriesController(req: am.MisReportCategoriesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMisReportCategories`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMisReportDefByCategoryController(req: am.MisReportDefByCategoryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMisReportDefByCategory`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBranchWiseRevenueController(req: am.BranchWiseRevenueRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBranchWiseRevenue`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }

    )
      .pipe(
      catchError(this.handleError)
    );
  }
  GetVendorInvoiceListController(req: am.VendorInvoiceListRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetVendorInvoiceList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    )
      .pipe(catchError(this.handleError));
  }
  GetVendorInvoiceDetailsController(req: am.VendorInvoiceDetailsRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetVendorInvoiceDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    )
      .pipe(catchError(this.handleError));
  }
  GetPurchaseOrdersListController(req: am.PurchaseOrdersListRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPurchaseOrdersList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    )
      .pipe(catchError(this.handleError));
  }
  GetPurchaseOrderDetailsController(req: am.PurchaseOrderDetailsRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPurchaseOrderDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    )
      .pipe(catchError(this.handleError));
  }
  GetPurchaseIndentsListController(req: am.PurchaseIndentsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPurchaseIndentsList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }

    )
      .pipe(
        catchError(this.handleError)
      );
  }
  GetPurchaseIndentItemsController(req: am.PurchaseIndentItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPurchaseIndentItems`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }

    )
      .pipe(
        catchError(this.handleError)
      );
  }
  SavePurchaseIndents(AddActorIdentitiesRequest: am.SavePurchaseIndentRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SavePurchaseIndents`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetInstantReportServiceController2(req: am.InstantReportRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetInstantReportDataset`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetInstantReportServiceController(req: am.InstantReportRequest) {
    let expheaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                //'application/ vnd.openxmlformats - officedocument.spreadsheetml.sheet'
      'AuthGenKEY': AppData.Instance().UserLoginDetails.AuthGenKEY
    });
   // let options = new RequestOptions({ headers: expheaders, responseType: ResponseContentType.Blob });

    return this.http.post(`${AppData.GlobalApiUrl}report/GetInstantReport`, (req),
      {
        headers: expheaders,
        responseType: 'blob'
      }
    )
      //{
      //  headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      //    .set('responseType', 'arraybuffer')
      //  //, observe: 'response' as 'body'
      //  //,responseType: 'blob' //as 'json'
        
      //}//, blob_options
    
     // .map((res) => res.FileStream._buffer)
      .pipe(
        catchError(this.handleError)
      );
    //return this.http.post<Response>(`${AppData.GlobalApiUrl}report/GetInstantReport`, (req),
    //  {
    //    headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
    //      .set('responseType', 'blob')
       
    //  }
    //)
    //  .map((res) => res.arrayBuffer)
    //  .pipe(
    //  catchError(this.handleError)
    //);
  }
  GetAdmissionsListController(req: am.AdmissionsListRequest) {

    return this.http.post<Response>(`${AppData.GlobalApiUrl}patient/GetAdmissionsList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
  
      }
    )
   //   .map(response => {
   //   return response;
   ////   let data = response.Result.content;
   ////   alert(data)
   //////   return data;

   ////    var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
   //// //  alert(response.content);
   ////   var blob = new Blob([data], {
   ////      type: contentType
   ////    });
   ////    return blob;
   // }
   // )
      .pipe(
      catchError(this.handleError)
    );
  }
  GetAdmissionsByCodeController(req: am.AdmissionsByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetAdmissionsByCode`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetExternalDoctorsListController(req: am.ExternalDoctorsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetExternalDoctorsList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetServiceCostByProviderController(req: am.ServiceCostByProviderRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetServiceCostByProvider`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabDepartmentsListController(req: am.LabDepartmentsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabDepartmentsList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetConsumptionGroupItemsController(req: am.ConsumptionGroupItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetConsumptionGroupItems`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetTestsByLabCodeController(req: am.TestsByLabCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTestsByLabCode`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabOrdersListController(req: am.LabOrdersListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabOrdersList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetTestInformationDetails(req: any) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTestInformationDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMasterObservations(req: any) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMasterObservations`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveTestInformation(req: any) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveTestInformation`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveSpecimenInfo(req: any) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSpecimenInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveObservationsInfo(req: any) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveObservationsInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveNotesInfo(req: any) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveNotesInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillAdvanceByCodeController(req: am.BillAdvanceByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBillAdvanceByCode`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetCustomCodeValuesController(req: am.CustomCodeTypeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetCustomCodeTypeRequest`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMaterialSpecsController(req: am.MaterialSpecsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMaterialSpecs`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMaterialConsumptionEntries2(req: am.MaterialConsumptionEntriesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMaterialConsumptionEntries`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabSpecimenCollectionController(req: am.LabSpecimenCollectionRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabSpecimenCollection`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabOrderResultsController(req: am.LabOrderResultsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabOrderResults`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabOrderResultsByTestController(req: am.LabOrderResultsByTestRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabOrderResultsByTest`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GenerateIahBill(req: am.GenerateIahBillRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GenerateIahBill`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  FinalizeConsumptionEntry(req: am.FinalizeConsumptionEntryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/FinalizeConsumptionEntry`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GenerateIahOrderFromBill(req: am.GenerateIahOrderFromBillRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GenerateIahOrderFromBill`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  CancelBill(req: am.CancelBillRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/CancelBill`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveMaterialBatchInfo(req: am.SaveMaterialBatchInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveMaterialBatchInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveConsumptionGroup(req: am.SaveConsumptionGroupRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveConsumptionGroup`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveTestResultsInfo(req: am.SaveTestResultsInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveTestResultsInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  x_SaveAccessRight(req: am.SaveAccessRightRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveAccessRight`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveResultStatusInfo(req: am.SaveResultStatusInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveResultStatusInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveSpecimenCollectionInfo(req: am.SaveSpecimenCollectionInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSpecimenCollectionInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveExternalDoctorInfo(req: am.SaveExternalDoctorInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveExternalDoctorInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveVendorInfo(req: am.SaveVendorInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveVendorInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SavePaymentModeInfo(req: am.SavePaymentModeInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SavePaymentModeInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveBillRefundsInfo(req: am.SaveBillRefundsInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveBillRefundsInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveRefundPayInfo(req: am.SaveRefundPayInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveRefundPayInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveConsumptionGroupItem(req: am.SaveConsumptionGroupItemRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveConsumptionGroupItem`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabOrderDetailsController(req: am.LabOrderDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabOrderDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetAccessRightsByRoleController(req: am.AccessRightsByRoleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetAccessRightsByRole`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIPBillServiceTrackingController(req: am.IPBillServiceTrackingRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIPBillServiceTracking`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabOrderTestsController(req: am.LabOrderTestsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabOrderTests`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIahOrderItemsController(req: am.IahOrderItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIahOrderItems`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetRefundListController(req: am.RefundListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetRefundList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  RefundDetailsInfoController(req: am.RefundItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetRefundItems`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetStoreLocationMaterialsController(req: am.StoreLocationMaterialsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetStoreLocationMaterials`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMaterialBatchInaStoreController(req: am.MaterialBatchInaStoreRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMaterialBatchInaStore`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIahOrderStatusTrackController(req: am.IahOrderStatusTrackRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIahOrderStatusTrack`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIahOrderItemStatus(req: am.SaveIahOrderItemStatusRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIahOrderItemStatus`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveRefundStatus(req: am.SaveRefundStatusRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveRefundStatus`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveMaterialDetailsInfo(req: am.SaveMaterialDetailsInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveMaterialDetailsInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIahOrderStatus(req: am.SaveIahOrderStatusRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIahOrderStatus`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveMaterialConsumptionEntries(req: am.SaveMaterialConsumptionEntriesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveMaterialConsumptionEntries`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMaterialsListController(req: am.MaterialsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMaterialsList`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetOrderTestDataByCodeController(req: am.OrderTestDataByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOrderTestDataByCode`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleEmbryoTransferrablesController(req: am.IvfCycleEmbryoTransferrablesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleEmbryoTransferrables`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLabOrderRequestsController(req: am.LabOrdersRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetLabOrderRequests`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleEmbryoTransferStoreController(req: am.IvfCycleEmbryoTransferStoreRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleEmbryoTransferStore`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveEmbryoTransferStore(req: am.SaveEmbryoTransferStoreRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveEmbryoTransferStore`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveMaterialToStoreInfo(req: am.SaveMaterialToStoreInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveMaterialToStoreInfo`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetBillDetailsInfoController(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBills`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillHeaderController(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillDetailsByProviderCode(req: am.x_BillDetailsByProviderCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetailsByProviderCode`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillReceiptsController(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetBillItemsController(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetails`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillDetailsInfoController2(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBills2`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillHeaderController2(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetails2`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillReceiptsController2(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetails2`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetBillItemsController2(req: am.x_BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/GetBillDetails2`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  X_SaveServiceItemTrackingStatus(AddActorIdentitiesRequest: am.SaveServiceItemTrackingStatusRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveServiceItemTrackingStatus`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetBranchWiseRegistrationsController(req: am.BranchWiseRegistrationsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBranchWiseRegistrations`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  generic_proc_post_large_data<ApiResponseModelLarge>(req: am.GenericProcPostRequest) {

    return this.http.post<ApiResponseModelLarge>(`${AppData.GlobalApiUrl}patient/GenericProcPost`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  generic_proc_post(req: am.GenericProcPostRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GenericProcPost`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBranchWiseRefundsController(req: am.BranchWiseRefundsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBranchWiseRefunds`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBranchWiseVendorInvoiceController(req: am.BranchWiseVendorInvoiceRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBranchWiseVendorInvoice`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBranchWiseDuesController(req: am.BranchWiseDuesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBranchWiseDues`, (req),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIPBillItemsInfo(AddActorIdentitiesRequest: am.SaveIPBillItemsInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIPBillItemsInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetTreatmentCycleInfoController(AddActorIdentitiesRequest: am.TreatmentCyclesInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTreatmentCyclesInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBedLocationsListController(AddActorIdentitiesRequest: am.BedLocationsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBedLocationsList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetItemWiseServiceController(AddActorIdentitiesRequest: am.ItemWiseServiceRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetItemWiseService`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetActorProfileController(AddActorProfileRequest: am.ActorProfileRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetActorProfile`, (AddActorProfileRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );

    //.pipe(catchError(this.handleError));
  }
  GetActorIdentitiesController(AddActorIdentitiesRequest: am.ActorIdentitiesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetActorIdentities`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularScansByCycleController(AddActorIdentitiesRequest: am.FollicularScansByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularScansByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetDSAActivityByCycleCodeController(AddActorIdentitiesRequest: am.DSAActivityByCycleCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetDSAActivityByCycleCode `, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetEmbryosFromStoreController(AddActorIdentitiesRequest: am.EmbryosFromStoreRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetEmbryosFromStore`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfEmbryoGradingByCycleController(AddActorIdentitiesRequest: am.IvfEmbryoGradingByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfEmbryoGradingByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveVendorInformation(AddActorIdentitiesRequest: am.SaveVendorInformationRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveVendorInformation`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveEmbryoGradingInfo(AddActorIdentitiesRequest: am.SaveEmbryoGradingInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveEmbryoGradingInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveEmbryoStoreInfo(AddActorIdentitiesRequest: am.SaveEmbryoStoreInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveEmbryoStoreInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveEmbryoStorageAreaInfo2(AddActorIdentitiesRequest: am.SaveEmbryoStorageAreaInfoRequest2) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveEmbryoStorageAreaInfo2`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveBillItemsInfo(AddActorIdentitiesRequest: am.SaveBillItemsInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveBillItemsInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveExpenseVoucher(AddActorIdentitiesRequest: am.SaveExpenseVoucherRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveExpenseVoucher`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveRefundApproval(AddActorIdentitiesRequest: am.SaveRefundApprovalRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveRefundApproval`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveOTFormDetail(AddActorIdentitiesRequest: am.SaveOTSectionDataRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveClinicalFormSectionData`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetExpenseVoucherController(AddActorIdentitiesRequest: am.ExpenseVoucherRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetExpenseVoucher`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetExpenseVouchersController(AddActorIdentitiesRequest: am.ExpenseVouchersRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetExpenseVouchers`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillHeaderWithItemsController(AddActorIdentitiesRequest: am.BillHeaderWithItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}billing/X_GetBillHeaderWithItems`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetRefundDetailsController(AddActorIdentitiesRequest: am.RefundDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetRefundsApprovalList_x`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetMaterialConsumptionItemsController(AddActorIdentitiesRequest: am.MaterialConsumptionItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetMaterialConsumptionItems`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  RefundDetailsData(AddActorIdentitiesRequest: am.RefundDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetRefundsApprovalByRefundCode_x`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  ConvertEmbryoGradingToWellCulture(AddActorIdentitiesRequest: am.ConvertEmbryoGradingToWellCultureRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/ConvertEmbryoGradingToWellCulture`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetVendorsListController(AddActorIdentitiesRequest: am.VendorsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetVendorsList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetCaseRecordSignatoryController(AddActorIdentitiesRequest: am.CaseRecordSignatoryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCaseRecordSignatory`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetOocyteMaturityByCycleController(AddActorIdentitiesRequest: am.OocyteMaturityByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOocyteMaturityByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetOocyteMaturityByCycleController2(AddActorIdentitiesRequest: am.OocyteMaturityByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOocyteMaturityByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetOocyteMorphologyByCycleController(AddActorIdentitiesRequest: am.OocyteMorphologyByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOocyteMorphologyByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleInseminationByCycleController(AddActorIdentitiesRequest: am.IvfCycleInseminationByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleInseminationByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetPatientVisitDetailsController(AddActorIdentitiesRequest: am.PatientVisitDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPatientVisitDetails`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleMembersListController(AddActorIdentitiesRequest: am.IvfCycleMembersListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleMembersList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetCaseRegistrationByActorCodeController(AddActorIdentitiesRequest: am.CaseRegistrationByActorCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCaseRegistrationByActorCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetPatientwiseLabReportsController(AddActorIdentitiesRequest: am.PatientwiseLabReportsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPatientwiseLabReports`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIahOrdersController(AddActorIdentitiesRequest: am.IahOrdersRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIahOrders`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetPatientwiseLabReportsByTestCodeController(AddActorIdentitiesRequest: am.PatientwiseLabReportsByTestCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPatientwiseLabReportsByTestCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveOocyteMaturityInfo(AddActorIdentitiesRequest: am.SaveOocyteMaturityInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveOocyteMaturityInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveiahOrder(AddActorIdentitiesRequest: am.SaveiahOrderRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveiahOrder`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfCycleInseminationInfo(AddActorIdentitiesRequest: am.SaveIvfCycleInseminationInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfCycleInseminationInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveOocyteMorphologyInfo(AddActorIdentitiesRequest: am.SaveOocyteMorphologyInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveOocyteMorphologyInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveAppointmentInformation2(AddActorIdentitiesRequest: am.AppointmentCancelRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/AppointmentCancel`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveAppointmentInformationNew(AddActorIdentitiesRequest: am.SaveAppointmentInformationNewRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveAppointmentInformationNew`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveAppointmentInformationNew2(AddActorIdentitiesRequest: am.SaveAppointmentInformationNewRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveAppointmentInformationNew2`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetTreatmentCycleActiityMasterController(AddActorIdentitiesRequest: am.IvfCycleActivityMasterRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleActivitiesList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetSingleWellCultureByCycleCodeController(AddActorIdentitiesRequest: am.SingleWellCultureByCycleCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetSingleWellCultureByCycleCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetTreatmentCycleStatusController(AddActorIdentitiesRequest: am.TreatmentCycleStatusRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTreatmentCycleStatus`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetReadyForPickUpsBetweenDateController(AddActorIdentitiesRequest: am.ReadyForPickUpsBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetReadyForPickUpsBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveCycleStatus(Request: am.SaveCycleStatusRequest) {
    return this.http.post<ApiRequestModel>(`${AppData.GlobalApiUrl}patient/SaveCycleStatus`, (Request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }

    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveSingleEmbryoGradeInfo(AddActorIdentitiesRequest: am.SaveSingleEmbryoGradeInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSingleEmbryoGradeInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  CompleteIvfCycleInsemination(AddActorIdentitiesRequest: am.CompleteIvfCycleInseminationRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/CompleteIvfCycleInsemination`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularScanDetailsByCodeController(AddActorIdentitiesRequest: am.FollicularScanDetailsByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularScanDetailsByCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularPickUpsDetailController(AddActorIdentitiesRequest: am.FollicularPickUpsDetailRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularPickUpsDetail`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetCycleSpermPreparationBetweenDateController(AddActorIdentitiesRequest: am.CycleSpermPreparationBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCycleSpermPreparationBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetEmbryoGradesBetweenDateController(AddActorIdentitiesRequest: am.EmbryoGradesBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetEmbryoGradesBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularPickUpsByCodeController(AddActorIdentitiesRequest: am.FollicularPickUpsByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularPickUpsByCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetLongCodeTypeValueController(AddActorIdentitiesRequest: am.LongCodeTypeValueRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetLongCodeTypeValue`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveNewsList(AddActorIdentitiesRequest: am.SaveNewsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveNewsList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveCodeTypes(AddActorIdentitiesRequest: am.CodeTypeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveCodeTypes`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveTestMedCycleActivities(AddActorIdentitiesRequest: am.SaveTestMedCycleActivitiesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveTestMedCycleActivities`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveCodeTypeValues(AddActorIdentitiesRequest: any) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/SaveCodeTypeValues`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveFollicularPickupsDetailV2(AddActorIdentitiesRequest: am.SaveFollicularPickupsDetailV2Request) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveFollicularPickupsDetailV2`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveFollicularPickupsDetail(AddActorIdentitiesRequest: am.SaveFollicularPickupsDetailRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveFollicularPickupsDetail`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfTreatmentCyclesInfo(AddActorIdentitiesRequest: am.SaveIvfTreatmentCyclesInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfTreatmentCyclesInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SavePatientInfo(AddActorIdentitiesRequest: am.SavePatientInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SavePatientInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  UpdatePatientInfo(AddActorIdentitiesRequest: am.UpdatePatientInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/UpdatePatientInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveActorDocs(AddActorIdentitiesRequest: am.ActorDocRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/SaveActorDocs`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetDoctorsListController(AddActorIdentitiesRequest: am.DoctorsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetDoctorsList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  //
  GetCycleOocyteQualityBetweenDateController(AddActorIdentitiesRequest: am.CycleOocyteQualityBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCycleOocyteQualityBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  ReadyForEmbroTransfer(AddActorIdentitiesRequest: am.ReadyForEmbroTransferRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/ReadyForEmbroTransfer`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetReadyForTransferBetweenDateController(AddActorIdentitiesRequest: am.ReadyForTransferBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetReadyForTransferBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleEmbryoStorageAreaController(AddActorIdentitiesRequest: am.IvfCycleEmbryoStorageAreaRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleEmbryoStorageArea`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveEmbryoStorageAreaInfo(AddActorIdentitiesRequest: am.SaveEmbryoStorageAreaInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveEmbryoStorageAreaInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfEmbryoTransferAttempt(AddActorIdentitiesRequest: am.SaveIvfEmbryoTransferAttemptRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfEmbryoTransferAttempt`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfCycleEmbryoTransferredInfo(AddActorIdentitiesRequest: am.SaveIvfCycleEmbryoTransferredInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfCycleEmbryoTransferredInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetIvfEmbryoTransferAttemptByCycleCodeController(AddActorIdentitiesRequest: am.IvfEmbryoTransferAttemptByCycleCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfEmbryoTransferAttemptByCycleCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleEmbryoTransferredController(AddActorIdentitiesRequest: am.IvfCycleEmbryoTransferredRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleEmbryoTransferred`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfPlanActivityTemplateController(AddActorIdentitiesRequest: am.IvfPlanActivityTemplateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfPlanActivityTemplate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfPlanTemplateController(AddActorIdentitiesRequest: am.IvfPlanTemplateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfPlanTemplate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  SaveAppointmentInformation(r: am.SaveAppointmentInformationRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveAppointmentInformation`, (r),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfPlanTemplate(AddActorIdentitiesRequest: am.SaveIvfPlanTemplateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfPlanTemplate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfPlanActivityTemplate(AddActorIdentitiesRequest: am.SaveIvfPlanActivityTemplateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfPlanActivityTemplate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillDetailsController(AddActorIdentitiesRequest: am.BillDetailsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBillDetails`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillsByFormattedCodeController(AddActorIdentitiesRequest: am.BillsByFormattedCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBillsByFormattedCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetBillItemsByChargeEntryCodeController(AddActorIdentitiesRequest: am.BillItemsByChargeEntryCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBillItemsByChargeEntryCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  UpdateIvfCycleByActivityV2(AddActorIdentitiesRequest: am.UpdateIvfCycleByActivityRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/UpdateIvfCycleByActivityV2`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfWorkbenchController(AddActorIdentitiesRequest: am.IvfWorkbenchRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfWorkbench`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularScansBetweenDateController(AddActorIdentitiesRequest: am.FollicularScansBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularScansBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularPickUpsBetweenDateController(AddActorIdentitiesRequest: am.FollicularPickUpsBetweenDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularPickUpsBetweenDate`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularScanDetailController(AddActorIdentitiesRequest: am.FollicularScanDetailRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularScanDetail`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetFollicularScanOvaryDetailController(AddActorIdentitiesRequest: am.FollicularScanOvaryDetailRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetFollicularScanOvaryDetail`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetAppointmentDetailsByAppointmentCodeContoller(data: am.AppointmentDetailsByAppointmentCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetAppointmentDetailsByAppointmentCode`, (data),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetProviderAvlSlotsContoller(data: am.ProviderAvlSlotsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetProviderAvlSlots`, (data),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SavePatientVisitInformation(AddActorIdentitiesRequest: am.SavePatientVisitRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SavePatientVisitInformation`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveClinicalForm(AddActorIdentitiesRequest: am.SaveClinicalFormRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveClinicalForm`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveFollicularScanDetail(AddActorIdentitiesRequest: am.SaveFollicularScanDetailRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveFollicularScanDetail`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfOocyteEmbryoStorage(AddActorIdentitiesRequest: am.SaveIvfOocyteEmbryoStorageRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfOocyteEmbryoStorage`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfSpermStore(AddActorIdentitiesRequest: am.SaveIvfSpermStoreRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfSpermStore`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetIvfOocyteEmbryoStorageByCodeController(AddActorIdentitiesRequest: am.IvfOocyteEmbryoStorageByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfOocyteEmbryoStorageByCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfSpermStoreByCodeController(AddActorIdentitiesRequest: am.IvfSpermStoreByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfSpermStoreByCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  SaveIvfCycleInseminationLog(AddActorIdentitiesRequest: am.SaveIvfCycleInseminationLogRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfCycleInseminationLog`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveFollicularScanOvaryDetail(AddActorIdentitiesRequest: am.SaveFollicularScanOvaryDetailRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveFollicularScanOvaryDetail`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveClinicalOrderRxHeaderInfo(AddActorIdentitiesRequest: am.SaveClinicalOrderRxHeaderInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveClinicalOrderRxHeaderInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetDoctorAppointmentsByDoctorcodeContoller(AddActorIdentitiesRequest: am.DoctorAppointmentsByDoctorCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetDoctorAppointmentsByDoctorcode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetClinicalOrderRxHeaderController(AddActorIdentitiesRequest: am.ClinicalOrderRxHeaderRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetClinicalOrderRxHeader`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetTradedDrugDetailViewController(AddActorIdentitiesRequest: am.TradedDrugDetailViewRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTradedDrugDetailView`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetClinicalOrderRxItemsController(AddActorIdentitiesRequest: am.ClinicalOrderRxItemsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetClinicalOrderRxItems`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetDoctorAppointmentsByDoctorcodeContoller2(AddActorIdentitiesRequest: am.DoctorAppointmentsByDoctorCode2Request) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetDoctorAppointmentsByDoctorcode2`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetNewsListController(AddActorIdentitiesRequest: am.NewsListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetNewsList`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleTestByCodeController(AddActorIdentitiesRequest: am.IvfCycleTestByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleTestByCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleMedicineByCodeController(AddActorIdentitiesRequest: am.IvfCycleMedicineByCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleMedicineByCode`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetCounsellingActivitiesByTimeController(AddActorIdentitiesRequest: am.CounsellingActivitiesByTimeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCounsellingActivitiesByTime`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveActorIdentities(SendActorIdentitiesRequest: am.ActorIdentitiesRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/SaveActorIdentities`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfCycleMedicineData(SendActorIdentitiesRequest: am.SaveIvfCycleMedicineDataRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfCycleMedicineData`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveIvfCycleTestData(SendActorIdentitiesRequest: am.SaveIvfCycleTestDataRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveIvfCycleTestData`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveProviderServiceChargeInfo(SendActorEducationInfoRequest: am.SaveProviderServiceChargeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveProviderServiceCharge`, (SendActorEducationInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveCounsellingPlan(SendActorIdentitiesRequest: am.SaveCounsellingPlanRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveCounsellingPlan`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveCounsellingActivity(SendActorIdentitiesRequest: am.SaveCounsellingActivityRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveCounsellingActivity`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveVitalItemData(SendActorIdentitiesRequest: am.SaveVitalItemRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveVitalItemData`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveCustomerMessage(SendActorIdentitiesRequest: am.SaveCustomerMessageRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveCustomerMessage`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveActorGuardianInfo(SendActorIdentitiesRequest: am.SaveGuardianInfoRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveGuardianInfo`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveArticleList(SendActorIdentitiesRequest: am.SaveArticleRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveArticleList`, (SendActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  //////////////////////////
  //
  GetActorImageController(AddActorImageRequest: am.ActorImageRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetActorImage`, (AddActorImageRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetCustomerMessageController(AddActorImageRequest: am.CustomerMessageRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCustomerMessage`, (AddActorImageRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetArticleListController(AddActorImageRequest: am.ArticleListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetArticleList`, (AddActorImageRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetServiceCategoriesController(SendActorServiceInfoRequest: am.ServiceCategoriesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetServiceCategories`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetCounsellingPlanController(SendActorServiceInfoRequest: am.CounsellingPlanRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCounsellingPlan`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetCounsellingActivityController(SendActorServiceInfoRequest: am.CounsellingActivityRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetCounsellingActivity`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetIvfTreatmentPlanController(SendActorServiceInfoRequest: am.IvfTreatmentPlanRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfTreatmentPlan`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetServicesByCategoryCodeController(SendActorServiceInfoRequest: am.ServicesByCategoryCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetServicesByCategoryCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetOocyteQualityAssessmentByCodeController(SendActorServiceInfoRequest: am.OocyteQualityAssessmentByCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOocyteQualityAssessmentByCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetCodeTypesController(SendActorServiceInfoRequest: am.CodeTypeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetCodeTypes`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveOocyteQualityAssessment(SendActorServiceInfoRequest: am.SaveOocyteQualityAssessmentRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveOocyteQualityAssessment`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveSemenData(SendActorServiceInfoRequest: am.SaveSemenDataRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSemenData`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveSpermDetails(SendActorServiceInfoRequest: am.SaveSpermDetailsRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSpermDetails`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveSingleWellFollicle(SendActorServiceInfoRequest: am.SaveSingleWellFollicleRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSingleWellFollicle`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetSpermSourceDetailsController(SendActorServiceInfoRequest: am.SpermSourceDetailsRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetSpermSourceDetails`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetSingleWellInseminationByCycleController(AddActorIdentitiesRequest: am.SingleWellInseminationByCycleRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetSingleWellInseminationByCycle`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  GetIvfCycleInseminationLogByCycleWithDOCController(AddActorIdentitiesRequest: am.IvfCycleInseminationLogByCycleWithDOCRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetIvfCycleInseminationLogByCycleWithDOC`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveSingleWellInseminationInfo(AddActorIdentitiesRequest: am.SaveSingleWellInseminationInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveSingleWellInseminationInfo`, (AddActorIdentitiesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  SaveTestCycleActivities(SendActorServiceInfoRequest: am.SaveTestCycleActivitiesRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveTestCycleActivities`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetServiceDetailsByCodeController(SendActorServiceInfoRequest: am.ServiceDetailsByCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetServiceDetailsByCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetServiceBranchMapByServiceCodeController(SendActorServiceInfoRequest: am.ServiceBranchMapByServiceCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetServiceBranchMapByServiceCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetServiceConsultantMapControllerController(SendActorServiceInfoRequest: am.ServiceConsultantMapRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetServiceConsultantMap`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetPatientInfoByFormattedCodeController(SendActorServiceInfoRequest: am.PatientInfoByFormattedCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetPatientInfoByFormattedCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetTreatmentCyclesController(SendActorServiceInfoRequest: am.TreatmentCyclesRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTreatmentCycles`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetTreatmentCyclesByActorCodeController(SendActorServiceInfoRequest: am.TreatmentCyclesByActorCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetTreatmentCyclesByActorCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetGuardianInfoController(SendActorServiceInfoRequest: am.GuardianInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetGuardianInfo`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetOTFormsByFormattedCodeController(SendActorServiceInfoRequest: am.OTFormsByFormattedCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOTFormsByFormattedCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetOTFormDetailByReportCodeController(SendActorServiceInfoRequest: am.OTFormDetailByReportCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetOTFormDetailByReportCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetActorDocController(SendActorServiceInfoRequest: am.ActorDocRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/GetActorDocByType`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetVitalItemHistoryByFormattedCodeController(SendActorServiceInfoRequest: am.VitalItemHistoryByFormattedCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetVitalItemHistoryByFormattedCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetVitalLatestFormByFormattedCodeController(SendActorServiceInfoRequest: am.VitalLatestFormByFormattedCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetVitalLatestFormByFormattedCode`, (SendActorServiceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //xUploadActorImage(formData, AddActorImageRequest: ActorImageRequest) {
  //  //console.log('apicall');
  //  return this.http.post(`${AppData.GlobalApiUrl}Doc/xUploadDoc`, (formData),
  //  //  {
  //  //  formData
  //  //   AddActorImageRequest
  //  //},
  //    {
  //      headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
  //        .set('ActorImageCode', AddActorImageRequest.ActorImageCode.toString())
  //        .set('xRequestType', AddActorImageRequest.SendApiRequestModel.xRequestType.toString())
  //        .set('FileExtension', AddActorImageRequest.FileExtension)
  //        .set('xUserName', AddActorImageRequest.SendApiRequestModel.xUserName),
  //    }
  //  ).pipe(catchError(this.handleError));

  //}

  ////////////////////////
  //xDownloadDoc(SendReqDownloadFileRequestRequest: DownloadFileRequestRequest) {
  //  return this.http.post(`${AppData.GlobalApiUrl}Doc/xUploadDoc`, SendReqDownloadFileRequestRequest, {
  //    headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
  //  }).map((res: Response) => res.arrayBuffer)
  //    .subscribe((result) => {
  //      var filename = Headers['x-filename'];
  //      var contentType = Headers['content-type'];

  //      var linkElement = document.createElement('a');

  //      {

  //        var blob = new Blob([result], {
  //          type: "application/octet-stream"
  //        });

  //        var url = window.URL.createObjectURL(blob);



  //        linkElement.setAttribute('href', url);

  //        linkElement.setAttribute("download", "Test.pdf");



  //        var clickEvent = new MouseEvent("click", {

  //          "view": window,

  //          "bubbles": true,

  //          "cancelable": false

  //        });

  //        linkElement.dispatchEvent(clickEvent);

  //      }


  //    }
  //    ,

  //    (error) => {

  //      alert('error---------------' + error.message);
  //    }
  //    );
  //}


  //
  GetEmployeesByFacilityCodeController(AddEmployeeInfoRequest: am.EmployeeInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetEmployeesByFacilityCode`, (AddEmployeeInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  xCreateEmployeeUserAccount(SendEmployeeUserAccountRequest: am.EmployeeUserAccountRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/xCreateEmployeeUserAccount`, (SendEmployeeUserAccountRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  //////////////////////////
  SaveEmployeeInfo(SendEmployeeInfoRequest: am.EmployeeInfoRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/SaveEmployeeInfo`, (SendEmployeeInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  //
  xChangePassword(xChangePasswordRequest: ChangePasswordRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/xChangePassword`, (xChangePasswordRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }

    ).pipe(
      catchError(this.handleError)
    );
  }
  //

  xChangeUserActivation(xChangeUserActivateRequest: ChangeUserActivateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/xChangeUserActivation`, (xChangeUserActivateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }

    ).pipe(
      catchError(this.handleError)
    );
  }

  //
  SaveFacilityInfo(SendFacilityInfoRequest: am.FacilityInfoRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/SaveFacilityInfo`, (SendFacilityInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  GetFacilityInfoController(AddFacilityInfoRequest: am.FacilityInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetFacilityInfo`, (AddFacilityInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  //
  SaveCompanyInfo(SendCompanyInfoRequest: am.CompanyInfoRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/SaveCompanyInfo`, (SendCompanyInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetCompanyInfoController(AddCompanyInfoRequest: am.CompanyInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetCompanyInfo`, (AddCompanyInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  xCreateFacilityUserAccount(SendFacilityUserAccountRequest: am.FacilityUserAccountRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/xCreateFacilityUserAccount`, (SendFacilityUserAccountRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  xCreateNurseUserAccount(SendNurseUserAccountRequest: am.NurseUserAccountRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/xCreateNurseUserAccount`, (SendNurseUserAccountRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  GetEmployeeDetailInfoController(SendEmployeeDetailInfoRequest: am.EmployeeDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetEmployeeDetailInfo`, (SendEmployeeDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveEmployeeDetailInfo(SendEmployeeDetailInfoRequest: am.EmployeeDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/SaveEmployeeDetailInfo`, (SendEmployeeDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //.............
  //
  GetFacilityDetailInfoController(SendFacilityDetailInfoRequest: am.FacilityDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetFacilityDetailInfo`, (SendFacilityDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveFacilityDetailInfo(SendFacilityDetailInfoRequest: am.FacilityDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/SaveFacilityDetailInfo`, (SendFacilityDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveAdmissionDetails(SendFacilityDetailInfoRequest: am.FacilityDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/SaveAdmissionDetails`, (SendFacilityDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  GetFaciliesInfoByTypeController(SendFacilitiesInfoByTypeRequest: am.FacilitiesInfoByTypeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Actor/GetFaciliesInfoByType`, (SendFacilitiesInfoByTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetItemWiseSalesController(SendFacilitiesInfoByTypeRequest: am.ItemWiseSalesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetItemWiseSales`, (SendFacilitiesInfoByTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetBillAdvancesListController(SendFacilitiesInfoByTypeRequest: am.BillAdvancesListRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}patient/GetBillAdvancesList`, (SendFacilitiesInfoByTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  GetFaciliesInfoByTypeControllerNew(SendFacilitiesInfoByTypeRequest: am.FacilitiesInfoByJobRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCare/GetFaciliesInfoByJob`, (SendFacilitiesInfoByTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    //  //return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
